export enum SEARCH {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453451
     */
    ALL_TAB = 'SEARCH_PLUS_ALL_TAB',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453455
     */
    DRIVE = 'SEARCH_PLUS_DRIVE_TAB',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453461
     */
    ZENDESK = 'SEARCH_PLUS_ZENDESK_TAB',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=14685234
     */
    SHAREPOINT = 'SEARCH_PLUS_SHAREPOINT_TAB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=10273872
     */
    SEARCH_RESULTS_FOR = 'FRONT.SEARCH_RESULTS_FOR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=76735581
     */
    RESULT_IS_PROMOTED = 'FRONT.SEARCH.RESULT_IS_PROMOTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96182003
     */
    HIDE_FILTERS = 'FRONT.SEARCH.HIDE_FILTERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96182011
     */
    SHOW_FILTERS = 'FRONT.SEARCH.SHOW_FILTERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=98745556
     */
    RESULT_IS_FEATURED = 'FRONT.SEARCH.RESULT_IS_FEATURED',
}
